'use client';
import { useLayoutState } from '../../_hooks/useLayoutState';

export const HamburgerButton: React.FC = () => {
  const { openMobileMenu } = useLayoutState();

  return (
    <div
      className="absolute inset-y-0 right-4 my-auto h-6 w-8"
      tabIndex={0}
      role="button"
      onClick={openMobileMenu}
    >
      <div className="absolute inset-x-0 top-[2px] m-auto h-[2px] w-full bg-main-100 " />
      <div className="absolute inset-0 m-auto h-[2px] w-full bg-main-100 opacity-100" />
      <div className="absolute inset-x-0 bottom-[2px] m-auto h-[2px] w-full bg-main-100 " />
    </div>
  );
};
